export default __webpack_public_path__ + "static/char-s-61-zh-Hant-2b4b77612d27b24464fb2c95f7d53364.webp";